<template>
  <div class="datetime" :aria-label="dayAriaLabel">
    <span
      v-if="rotaDateIsToday(rota.startDate, dayIndex)"
      class="badge bg-success me-1"
      >today</span
    >
    <span class="date-text">{{
      formatDateAsDayWithSuffixShortMonth(rota.startDate, dayIndex)
    }}</span>
    <template v-if="currentShiftsForUserId?.length > 0">
      <span class="shift-time">
        [{{ formatTimeHoursMins(currentShiftsForUserId[0].startDate) }} -
        {{ formatTimeHoursMins(currentShiftsForUserId[0].endDate) }}]
      </span>
    </template>
    <span v-else class="shift-time no-current">No shifts</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import {
  rotaDateIsToday,
  formatTimeHoursMins,
  formatDateAsDayWithSuffixShortMonth,
  // @ts-expect-error date-functions is JavaScript and currently has no declaration file.
} from "../../../lib/date-functions";

const { rota, dayIndex, currentShiftsForUserId } = defineProps({
  rota: {
    type: Object,
    required: true,
  },
  dayIndex: {
    type: Number,
    required: true,
  },
  currentShiftsForUserId: {
    type: Object,
    required: true,
  },
});

const dayAriaLabel = computed(() => {
  let dayText = `${formatDateAsDayWithSuffixShortMonth(rota.startDate, dayIndex)}${rotaDateIsToday(rota.startDate, dayIndex) ? " (today)" : ""}`;

  if (currentShiftsForUserId.length > 0) {
    dayText +=
      " " +
      formatTimeHoursMins(currentShiftsForUserId[0].startDate) +
      " to " +
      formatTimeHoursMins(currentShiftsForUserId[0].endDate);
  } else {
    dayText += " No shifts";
  }
  return dayText;
});
</script>
